import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { FileTransferAccesses } from "./accesses.ts";
import { FileTransferComponents } from "./components.ts";

const FileTransferFilters = {
  destination: { keys: ["arn", "id", "name"], labeler: { arn: "ARN" } },
  instanceRegion: { keys: ["id"] },
  parent: { keys: ["id"], labeler: { id: "Account" } },
} as const satisfies AnyFilterSchema;

export type FileTransferFilters = typeof FileTransferFilters;

export const FileTransferRegistration = Registration({
  accesses: FileTransferAccesses,
  category: "resource",
  components: FileTransferComponents,
  docs: {
    install: "file-transfer",
    request: "file-transfer/transferring-files",
  },
  filters: FileTransferFilters,
  itemKind: "account",
  label: "File transfer",
  logoUrl: "/file-transfer.png",
  maturity: "beta",
  requestType: "requestable",
  // TODO: Should map iam_write, but was copied from existing code that omitted this mapping
  useMapping: [],
});

registerIntegration("file-transfer", FileTransferRegistration);
